import React, { useEffect, useState, useRef } from 'react';
import { connect } from 'react-redux';
import { useDispatch } from 'react-redux';
import { CellularModeEnum, CellularModeByArrayEnum, ButtonMode } from '../Esim/esimEnums';
import CellularItem from './CellularItem';
import { setButtonsModeInCellularOrder, setButtonsModeTypeInCellularOrder, setIsEsimNiudButton } from '../saleBlockSlice';

const CellularOrderDetails = (props) => {
  const selectedProducts = props.selectedProducts;
  const orderList = useRef([]);
  const dispatch = useDispatch();
  const [orderDetails, setOrderDetails] = useState(<></>);
  useEffect(() => {
    let buttonsMode = 0;
    const getModeType = (product) => {
      let arrayState = [product?.isEsim == undefined ? 'false' : product?.isEsim, product?.isExistPhone];
      console.log(arrayState.toString());
      switch (arrayState.toString()) {
        case CellularModeByArrayEnum.ESIM:
          if (buttonsMode < ButtonMode.SHOW_NIUD) {
            buttonsMode = ButtonMode.INSTALL_ESIM;
            dispatch(setButtonsModeInCellularOrder(ButtonMode.INSTALL_ESIM));
          }
          return CellularModeEnum.ESIM;
        case CellularModeByArrayEnum.ESIM_NIUD:
          dispatch(setIsEsimNiudButton(true));
          dispatch(setButtonsModeTypeInCellularOrder(CellularModeEnum.ESIM_NIUD));
          buttonsMode = ButtonMode.SHOW_NIUD;
          dispatch(setButtonsModeInCellularOrder(ButtonMode.SHOW_NIUD));
          return CellularModeEnum.ESIM_NIUD;
        case CellularModeByArrayEnum.SIM:
          dispatch(setButtonsModeInCellularOrder(ButtonMode.INSTALL_SIM));
          //dispatch(setShowButtonsInCellularOrder(true));
          return CellularModeEnum.SIM;
        case CellularModeByArrayEnum.SIM_NIUD:
          dispatch(setButtonsModeInCellularOrder(ButtonMode.SHOW_NIUD));
          buttonsMode = ButtonMode.SHOW_NIUD;
          return CellularModeEnum.SIM_NIUD;
        default:
          break;
      }
    };

    //Some logic to add products by mode to list
    selectedProducts.forEach((product) => {
      let modeType = getModeType(product);
      let itemWithSpecificModeType = orderList.current.find((w) => w.modeType == modeType);
      let isExistMode = itemWithSpecificModeType != null;
      if (isExistMode) {
        if (modeType == CellularModeEnum.ESIM_NIUD || modeType == CellularModeEnum.SIM_NIUD) {
          itemWithSpecificModeType.phoneNumbers.push(product.existPhone);
        } else {
          itemWithSpecificModeType.phoneNumbers.push(product.newPhone);
        }
      } else {
        let modeDisplayName = '';
        let textItems = [];
        let title = '';
        switch (modeType) {
          case CellularModeEnum.ESIM:
            modeDisplayName = 'הפעלת eSIM';
            textItems = props.esim?.InstructionEsim?.value;
            title = 'כיצד מפעילים?';
            break;
          case CellularModeEnum.ESIM_NIUD:
            modeDisplayName = 'ניוד והפעלת eSIM';
            textItems = props.esim?.InstructionEsimNiud?.value;
            title = 'מה עושים עכשיו?';
            break;
          case CellularModeEnum.SIM:
            modeDisplayName = 'קו חדש';
            textItems = ['ה-SIM נשלח אליכם בדואר.כשתקבלו אותו תוכלו להכניס את ה-SIM למכשיר ולהפעיל את השירות'];
            title = 'מה הלאה?';
            break;
          case CellularModeEnum.SIM_NIUD:
            modeDisplayName = 'ניוד קו';
            textItems = ['ה-SIM נשלח אליכם בדואר.כשתקבלו אותו תוכלו לנייד ולהפעיל את השירות'];
            title = 'כיצד מפעילים?';
            break;
        }

        let orderItem = {
          modeType: modeType,
          modeDisplayName: modeDisplayName,
          title: title,
          textItems: textItems,
          phoneNumbers:
            modeType == CellularModeEnum.ESIM_NIUD || modeType == CellularModeEnum.SIM_NIUD ? [product.existPhone] : [product.newPhone],
        };
        orderList.current.push(orderItem);
      }
    });
    let CellularOrderComponent = orderList.current.map((orderItem) => <CellularItem orderItem={orderItem} esim={props.esim} />);
    setOrderDetails(CellularOrderComponent);
  }, []);

  return orderDetails;
};

const mapStateToProps = (state) => {
  return {
  };
};

const mapDispatchToProps = { setButtonsModeInCellularOrder, setButtonsModeTypeInCellularOrder, setIsEsimNiudButton};

export default connect(mapStateToProps, mapDispatchToProps)(CellularOrderDetails);

